import React, { useState } from "react";
import "./AnimatedCard.scss";
import { useNavigate } from "react-router-dom";

import img1 from "../../../src/Assets/live_doctor.png";
import img2 from "../../../src/Assets/writing_d.png";
import img3 from "../../../src/Assets/Placeholder.png";
import { WHY_CHOOSE_CARDS, WHY_PATIENTS_TAGLINE } from "../../content/landingContent";

export default function AnimatedCard() {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(null);

    const cards = WHY_CHOOSE_CARDS.map((card, index) => ({
        ...card,
        img: [img1, img2, img3][index],
    }));

    return (
        <div className="ani_card">
            <div className="what">
                <h1>Why patients choose HealBid</h1>
                <p>{WHY_PATIENTS_TAGLINE}</p>
            </div>
            <div className="cards-container">

                {cards.map((card, index) => (
                    <div
                        key={index}
                        className={`card-wrapper ${openIndex === index ? "active" : ""}`}
                        onMouseEnter={() => setOpenIndex(index)}
                        onMouseLeave={() => setOpenIndex(null)}
                    >
                        {/* IMAGE */}
                        <div className="img-box">
                            <img src={card.img} alt="" />
                        </div>

                        {/* CONTENT */}
                        <div className="content-box">
                            <p className="small">{card.small}</p>
                            <h2>{card.title}</h2>
                            <p>{card.desc}</p>

                            <div
                                className="explore"
                                onClick={() => navigate("/get-started")}
                            >
                                Explore →
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
